var inicial = {
	templateUrl: './inicial.html',
	controller: 'InicialController',
	controllerAs: 'vm'
};

angular
	.module('components.inicial')
	.component('inicial', inicial)
	.config(function ($stateProvider, $urlRouterProvider) {
		$stateProvider
			.state('inicial', {
				parent: 'app',
				url: '/inicial',
				component: 'inicial',
				resolve: {}
			});
		$urlRouterProvider.otherwise('/app/inicial');
	});
